/**
 * VeriWine REST API
 * Defintion of VeriWine REST API
 *
 * OpenAPI spec version: 0.1.1
 * Contact: info@short.ch
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import {Inject, Injectable} from '@angular/core';
import {HttpClient, HttpResponse, HttpHeaders} from '@angular/common/http';
import {Observable, of} from 'rxjs';
import {SERVER_URL} from './server-url';
import {ApiUtilsService} from './api-utils.service'
import {
    PageWinePalletDto,
    TagStatusDto,
    WinePalletDto
} from '../domain';


@Injectable({
    providedIn: 'root'
})
export class WinePalletControllerService {

    constructor(
        @Inject(SERVER_URL) private _serverUrl: string,
        private _httpClient: HttpClient,
        private _apiUtils: ApiUtilsService
    ) {
    }

    private _headers: HttpHeaders = undefined;

    addCustomHeader(headerName: string, headerValue: string | string[]): this {
        if (!this._headers) {
            this._headers = new HttpHeaders();
        }
        this._headers = this._headers.append(headerName, headerValue);
        return this;
    }


        addBoxToPallet(
                    tid: string
                , 
                queryParams: {
                    boxTid: string
                }
    ): Observable<number> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/pallet/add/${tid}/box`;

            return this._httpClient.put<number>(url, requestBody, requestOptions);
    }


        checkTagStatus1(
                    tid: string
    ): Observable<TagStatusDto> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const requestOptions = {observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/pallet/${tid}/status`;

            return this._httpClient.get<TagStatusDto>(url, requestOptions);
    }


        createNewWinePallet(
                
                queryParams: {
                    userLegalEntityId: number
                }
                    
                    , 
                    requestBody: WinePalletDto
    ): Observable<number> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;

            const url: string = `${this._serverUrl}/api/pallet/`;

            return this._httpClient.post<number>(url, requestBody, requestOptions);
    }


        getWinePalletById(
                    id: number
    ): Observable<WinePalletDto> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const requestOptions = {observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/pallet/${id}`;

            return this._httpClient.get<WinePalletDto>(url, requestOptions);
    }


        getWinePalletByTid(
                    tid: string
    ): Observable<WinePalletDto> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const requestOptions = {observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/pallet/${tid}/tid`;

            return this._httpClient.get<WinePalletDto>(url, requestOptions);
    }


        loadPageByProducer1(
                    orgUnitId: number
                , 
                queryParams: {
                    userLegalEntityId: number,
                    page?: number,
                    size?: number,
                    sort?: Array<string>
                }
    ): Observable<PageWinePalletDto> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/pallet/page/${orgUnitId}`;

            return this._httpClient.get<PageWinePalletDto>(url, requestOptions);
    }


        removeBoxFromPallet(
                    tid: string
                , 
                queryParams: {
                    boxTid: string
                }
    ): Observable<number> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/pallet/remove/${tid}/box`;

            return this._httpClient.put<number>(url, requestBody, requestOptions);
    }


}

